import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/styles/design-v3-editor-viewport.css";
import "@/styles/pdf-studio-mobile-preview.css";
import "@/styles/master-content-detail-scroll.css";
import '@/i18n';
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);